import { useEffect, useState } from "react";
import { Card, CardBody, Table, TableHeader, TableBody, TableColumn, TableRow, TableCell, Button, Input, Modal, ModalBody, ModalHeader, ModalFooter, Textarea, ScrollShadow, ModalContent, Spinner } from "@heroui/react";
import { FolderPlus, BarChart, PlusCircle, TagIcon, Trash2Icon, PencilIcon, PencilLineIcon, Search } from "lucide-react";
import { motion } from "framer-motion";
import { useToast } from "../../context/toast";
import api from "../../api/api";
import WarningModal from "../../components/Modal/warning";
import { filter } from "framer-motion/client";

export default function CategoriesSection() {
  const [categories, setCategories] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showToast = useToast()
  const [isOpen, setIsOpen] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const [selectedId, setSelected] = useState(null)
  const [selectedEditCat, setSelectedEditCat] = useState(null)
  const [searchQuery, setSearchQuery] = useState('')
  // 📌 Gérer l'ajout d'une nouvelle catégorie


  const handleDeleteCategory = async (id)=>{


    try{
      
        setIsDeleting(true)
        await api.category.delete({id : selectedId})

        setCategories((prev)=>([...prev.filter((dt)=>dt.id !== selectedId)]))
        setIsDeleting(false)
        setSelected(null)
        
    }catch(e){
        console.log(e)
        setIsDeleting(false)
    }

  }


  const handleAddCategory = async () => {

    if (!name) return;


    try{

        const rep = await api.category.create({name : name, description : description})

        setCategories((prev)=>[...prev, {...rep, stats: { produits: 0, ventes: 0 }}])

        showToast("Categorie créée avec success", "success")
        setIsModalOpen(false)

        setName(null)
        setdescription(null)


    }catch(e){

        showToast("Une erreur s'est produite", "error")

    }

  };

  const [name, setName] = useState()
  const [description, setdescription] = useState()

  useEffect(()=>{

    const fetch = async ()=>{

        try{

            const data = await api.category.read()

            setCategories(data)


        }catch(e){

            console.log(e)

        }
    }

    fetch()

  }, [])


  const handleUpdateCategory = async ()=>{

    try {

      await api.category.update(selectedEditCat)

      
      setCategories((prev)=>{
        
        const filtered = prev.filter((item)=>{

          if(item.id === selectedEditCat.id){

            item.name = selectedEditCat.name
            item.description = selectedEditCat.description

          }

          return item

        })

        return [...filtered]

      })
      
      setSelectedEditCat(null)
      showToast("Categrie modifiée avec success", "success")

      
    } catch (error) {
      showToast("Nous avons rencontré une lors lors de la modification", "error")
    }
  }


  const filteredCategory = categories.filter((item)=>(item.name.includes(searchQuery) || searchQuery === '')).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))

  return (
    <div className="p-6 space-y-6">
      {/* 📌 HEADER */}
      <div className="flex items-center justify-between">
        <div className="flex justify-start items-center space-x-2">
          <h2 className="flex items-center gap-2 text-2xl font-semibold">
            <TagIcon size={24} className="text-primary" /> Catégories
          </h2>
          <Button color="primary" size="sm" onPress={() => setIsModalOpen(true)}>
            <PlusCircle size={18} className="mr-2" /> Ajouter une Catégorie
          </Button>
        </div>

        <div>
          <Input
            placeholder="🔍 Rechercher un produit..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            startContent={<Search size={18} />}
          />
        </div>

      </div>

      {/* 📌 LISTE DES CATÉGORIES AVEC SCROLL INTERNE */}
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
          <Table 

            aria-label="Table des catégories"
            isHeaderSticky 
            loadingContent={<Spinner color="primary" />}
            isStriped 
            classNames={{
              base: "max-h-[77vh]",
            }}
          >
            <TableHeader>
              <TableColumn>Nom</TableColumn>
              <TableColumn>Description</TableColumn>
              <TableColumn>Actions</TableColumn>
              {/* <TableColumn>Produits</TableColumn>
              <TableColumn>Ventes</TableColumn> */}
            </TableHeader>
            <TableBody emptyContent={'No product found'}>
              {filteredCategory.map((cat) => (

                <TableRow key={cat.id}>
                  <TableCell>{cat.name}</TableCell>
                  <TableCell className="truncate">{cat.description}</TableCell>
                  <TableCell className="flex justify-center items-center space-x-4">
                    <Button 
                      isIconOnly 
                      isLoading={selectedEditCat?.id === cat.id} 
                      onPress={()=>{setSelectedEditCat(cat)}}  
                      size="sm" 
                      className="bg-primary bg-opacity-20"
                    >
                        <PencilIcon className="w-4 h-4 text-primary"/>
                    </Button>

                    <Button 
                      isIconOnly 
                      isLoading={selectedId === cat.id} 
                      onPress={()=>{setSelected(cat.id) ; setIsOpen(true)}}  
                      size="sm" 
                      className="bg-red-600 bg-opacity-20"
                    >
                        <Trash2Icon className="w-4 h-4 text-red-700"/>
                      </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
      </motion.div>

      <WarningModal
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        title="Suppression d'un produit"
        message="Cette action supprimera définitivement le produit. Êtes-vous sûr ?"
        onConfirm={handleDeleteCategory}
      />

      {/* 📌 MODAL AJOUT CATÉGORIE */}
      <Modal isOpen={isModalOpen} onOpenChange={() => setIsModalOpen(false)} isDismissable>
        <ModalContent>
            <ModalHeader>
            <FolderPlus size={24} className="mr-2 text-primary" /> Ajouter une Catégorie
            </ModalHeader>
            <ModalBody>
            <input
                label="Nom de la Catégorie"
                placeholder="Ex: Produits Bio"
                value={name || ''}
                className="p-2 border rounded-lg shadow-sm focus:outline-primary dark:border-zinc-700 dark:bg-zinc-700"
                onChange={(e) => setName( e.target.value)}
                isRequired
            />
            <textarea
                label="Description"
                placeholder="Décrivez la catégorie"
                value={description || ''}
                onChange={(e) => setdescription(e.target.value)}
                className="p-2 border rounded-lg shadow-sm focus:outline-primary dark:border-zinc-700 dark:bg-zinc-700"
            />
            </ModalBody>
            <ModalFooter>
            <Button color="primary" onPress={handleAddCategory}>Ajouter</Button>
            </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={selectedEditCat} onOpenChange={() => setSelectedEditCat(null)} isDismissable>
        <ModalContent>
            <ModalHeader>
            <PencilLineIcon size={24} className="mr-2 text-primary" /> Modifier une Catégorie
            </ModalHeader>
            <ModalBody>
            <input
                label="Nom de la Catégorie"
                placeholder="Ex: Produits Bio"
                name="name"
                value={selectedEditCat?.name || ''}
                className="p-2 border rounded-lg shadow-sm focus:outline-primary dark:border-zinc-700 dark:bg-zinc-700"
                onChange={(e) => setSelectedEditCat((prev)=>({...prev, [e.target.name] : e.target.value}))}
                isRequired
            />
            <textarea
                label="Description"
                placeholder="Décrivez la catégorie"
                name="description"
                value={selectedEditCat?.description || ''}
                onChange={(e) => setSelectedEditCat((prev)=>({...prev, [e.target.name] : e.target.value}))}
                className="p-2 border rounded-lg shadow-sm focus:outline-primary dark:border-zinc-700 dark:bg-zinc-700"
            />
            </ModalBody>
            <ModalFooter>
            <Button color="primary" onPress={handleUpdateCategory}>Modifier</Button>
            </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
}
